import type { SystemStyleObject } from "@chakra-ui/styled-system";
import { SystemStyleFunction } from "@chakra-ui/theme-tools";

const baseStyleControl: SystemStyleFunction = (props) => {
  return {
    w: "100%",
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "4",
    borderColor: "outline",
    color: "on-primary",

    _checked: {
      bg: "primary",
      borderColor: "primary",
      color: "on-primary"
    },

    _disabled: {
      opacity: 0.4,
      pointerEvents: "none"
    }
  };
};

const baseStyleIcon: SystemStyleObject = {
  transitionProperty: "transform",
  transitionDuration: "normal"
};

const baseStyle: SystemStyleFunction = (props) => ({
  icon: baseStyleIcon,
  control: baseStyleControl(props)
});

const sizes = {
  md: {
    control: { w: 20, h: 20 },
    label: { fontSize: "md" },
    icon: { fontSize: "0.625rem" }
  }
};

const defaultProps = {
  size: "md"
};

export default {
  baseStyle,
  sizes,
  defaultProps
};
